<template>
  <div class="card">
    <div class="p-6">
      <div class="text-2xl font-semibold flex items-center gap-2 mb-6">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-primary">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
        人口学信息
      </div>

      <div class="space-y-8">
        <!-- 年龄段 -->
        <div class="space-y-3">
          <div class="flex items-center justify-between">
            <label class="text-base font-medium">
              {{ pronoun }}年龄段
              <span class="text-red-500 ml-1">*</span>
            </label>
          </div>
          <div class="grid grid-cols-1 gap-3">
            <label v-for="(option, index) in ageOptions" :key="index" 
              class="flex items-center space-x-3 cursor-pointer p-2 rounded hover:bg-gray-50 transition-colors">
              <input 
                type="radio" 
                v-model="formData.age"
                :value="index"
                class="h-4 w-4 text-psychology-primary focus:ring-psychology-primary"
              />
              <span class="text-sm">{{ option }}</span>
            </label>
          </div>
        </div>

        <!-- 性别 -->
        <div class="space-y-3">
          <div class="flex items-center justify-between">
            <label class="text-base font-medium">
              {{ pronoun }}性别
              <span class="text-red-500 ml-1">*</span>
            </label>
          </div>
          <div class="grid grid-cols-1 gap-3">
            <label v-for="(option, index) in genderOptions" :key="index"
              class="flex items-center space-x-3 cursor-pointer p-2 rounded hover:bg-gray-50 transition-colors">
              <input 
                type="radio" 
                v-model="formData.gender"
                :value="index + 1"
                class="h-4 w-4 text-psychology-primary focus:ring-psychology-primary"
              />
              <span class="text-sm">{{ option }}</span>
            </label>
          </div>
        </div>

        <!-- 星座 -->
        <div class="space-y-3">
          <div class="flex items-center justify-between">
            <label class="text-base font-medium">{{ pronoun }}星座（可选）</label>
            <span class="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">可选</span>
          </div>
          <div class="grid grid-cols-1 gap-3">
            <label v-for="(option, index) in zodiacOptions" :key="index"
              class="flex items-center space-x-3 cursor-pointer p-2 rounded hover:bg-gray-50 transition-colors">
              <input 
                type="radio" 
                v-model="formData.zodiac"
                :value="index"
                class="h-4 w-4 text-psychology-primary focus:ring-psychology-primary"
              />
              <span class="text-sm">{{ option }}</span>
            </label>
          </div>
        </div>

        <!-- 恋爱状态 -->
        <div class="space-y-3">
          <div class="flex items-center justify-between">
            <label class="text-base font-medium">
              {{ subjectPronoun }}目前的恋爱状态
              <span class="text-red-500 ml-1">*</span>
            </label>
          </div>
          <div class="grid grid-cols-1 gap-3">
            <label v-for="(option, index) in relationshipStatusOptions" :key="index"
              class="flex items-center space-x-3 cursor-pointer p-2 rounded hover:bg-gray-50 transition-colors">
              <input 
                type="radio" 
                v-model="formData.relationshipStatus"
                :value="index + 1"
                class="h-4 w-4 text-psychology-primary focus:ring-psychology-primary"
              />
              <span class="text-sm">{{ option }}</span>
            </label>
          </div>
        </div>

        <!-- 恋爱时长 -->
        <div class="space-y-3">
          <div class="flex items-center justify-between">
            <label class="text-base font-medium">当前/最近一段恋爱的持续时间</label>
            <span class="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">可选</span>
          </div>
          <div class="grid grid-cols-1 gap-3">
            <label v-for="(option, index) in relationshipDurationOptions" :key="index"
              class="flex items-center space-x-3 cursor-pointer p-2 rounded hover:bg-gray-50 transition-colors">
              <input 
                type="radio" 
                v-model="formData.relationshipDuration"
                :value="index"
                class="h-4 w-4 text-psychology-primary focus:ring-psychology-primary"
              />
              <span class="text-sm">{{ option }}</span>
            </label>
          </div>
        </div>

        <!-- 隐私提示 -->
        <div class="bg-gray-50 p-4 rounded-lg border border-gray-200">
          <h4 class="font-medium text-sm mb-2">隐私保护</h4>
          <p class="text-xs text-gray-600 leading-relaxed">
            以上信息仅用于提供个性化的结果分析，所有数据均在您的设备本地处理，
            不会上传到任何服务器。您可以随时删除这些数据。
          </p>
        </div>

        <!-- 按钮 -->
        <div class="flex justify-between pt-4 border-t">
          <button 
            @click="$emit('back')"
            class="btn-secondary"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
              <path d="m12 19-7-7 7-7"></path>
              <path d="M19 12H5"></path>
            </svg>
            返回
          </button>
          <button 
            @click="handleSubmit"
            :disabled="!isFormValid"
            :class="[
              'btn-primary ml-auto',
              !isFormValid && 'opacity-50 cursor-not-allowed'
            ]"
          >
            继续评估
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
              <path d="M5 12h14"></path>
              <path d="m12 5 7 7-7 7"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BasicInfoForm',
  props: {
    assessmentType: {
      type: String,
      default: 'self'
    }
  },
  data() {
    return {
      formData: {
        age: null,
        gender: null,
        zodiac: null,
        relationshipStatus: null,
        relationshipDuration: null
      },
      ageOptions: [
        '18岁以下',
        '18-24岁',
        '25-29岁',
        '30-34岁',
        '35-39岁',
        '40岁以上'
      ],
      genderOptions: [
        '男性',
        '女性',
        '其他',
        '不愿透露'
      ],
      zodiacOptions: [
        '不清楚/不愿透露',
        '白羊座',
        '金牛座',
        '双子座',
        '巨蟹座',
        '狮子座',
        '处女座',
        '天秤座',
        '天蝎座',
        '射手座',
        '摩羯座',
        '水瓶座',
        '双鱼座'
      ],
      relationshipStatusOptions: [
        '单身（从未恋爱）',
        '单身（曾经恋爱过）',
        '热恋期',
        '稳定期',
        '平淡期',
        '冷战期',
        '已婚/订婚',
        '异地恋'
      ],
      relationshipDurationOptions: [
        '从未恋爱',
        '少于3个月',
        '3-6个月',
        '6个月-1年',
        '1-2年',
        '2-3年',
        '3年以上'
      ]
    }
  },
  computed: {
    pronoun() {
      console.log('pronoun computed, assessmentType:', this.assessmentType)
      return this.assessmentType === 'self' ? '您的' : 'Ta的'
    },
    subjectPronoun() {
      console.log('subjectPronoun computed, assessmentType:', this.assessmentType)
      return this.assessmentType === 'self' ? '您' : 'Ta'
    },
    isFormValid() {
      return this.formData.age !== null && 
             this.formData.gender !== null && 
             this.formData.relationshipStatus !== null
    }
  },
  watch: {
    assessmentType: {
      handler(newVal) {
        console.log('assessmentType changed to:', newVal)
      },
      immediate: true
    }
  },
  methods: {
    handleSubmit() {
      if (this.isFormValid) {
        this.$emit('submit', this.formData)
      } else {
        // 检查哪些必填项未填写
        const missing = []
        if (this.formData.age === null) missing.push('年龄段')
        if (this.formData.gender === null) missing.push('性别')
        if (this.formData.relationshipStatus === null) missing.push('恋爱状态')
        
        // 使用toast显示错误
        this.$toast.error(`请填写必填项：${missing.join('、')}`, {
          timeout: 4000
        })
      }
    }
  }
}
</script>

